export default "__VITE_ASSET__CDYRJV3S__"